import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  getElementsStructure,
  updateBasicInformationElementStructure as updateBasicInformationElementStructureService,
  updateChildrenElementStructure as updateElementsElementStructureService,
  updateTypeChildrenElementStructure as updateTypeElementsElementStructureService,
} from "../../services/curriculum/elements-structure.service";
import { changedCurriculum, updateElementsStructure } from "../../store/actions/curriculum.actions";
import { useParams } from "react-router-dom";
import { validate } from "../../utils";
import isEmpty from "lodash/isEmpty";
import { handlerErrorV2 } from "../../utils/errors";
import { useSnackbar } from "notistack";

const useCurriculumElementsStructure = () => {
  const { curriculumId } = useParams()
  const { enqueueSnackbar } = useSnackbar()

  const dispatch = useDispatch();
  const [isLoadingList, setIsLoadingList] = useState(false);
  const [errors, setErrors] = useState({});

  const fetchLcElement = useCallback(async () => {
    setIsLoadingList(true);
    try {
      const response = await getElementsStructure(curriculumId);
      dispatch(updateElementsStructure(response?.data || {}));
    } catch (error) {
      setErrors({ message: error.message || 'An error ocurred'});
    } finally {
      setIsLoadingList(false);
    }
  }, []);

  useEffect(() => {
    fetchLcElement();
  }, []);

  const validateForm = (form) => {
    const fieldRules = {
      code: 'required|withoutSpaces',
      name: 'required',
      shortName: 'required',
    }

    const errors = validate(fieldRules, form)
    if (!isEmpty(errors)) {
      return { error: true, ...errors }
    }

    return { error: false }
  }

  const updateBasicInformationElementStructure = async (form = {}) => {
    const result = validateForm(form);
    if (result.error) {
      return result
    };

    try {
      const response = await updateBasicInformationElementStructureService(curriculumId, form);
      if (!response.data && response.error) {
        return { error: true, message: response.error.message || 'An error ocurred'}
      } else {
        dispatch(updateElementsStructure(response?.data || {}));
        dispatch(changedCurriculum());
        enqueueSnackbar('Element updated successfully', { variant: 'success' })
        return { error: false }
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      return { error: true, message }
    }
  }

  const updateElementsElementStructure = async (form = {}) => {
    try {
      const response = await updateElementsElementStructureService(curriculumId, form);
      if (!response.data && response.error) {
        return { error: true, message: response.error.message || 'An error ocurred'}
      } else {
        dispatch(updateElementsStructure(response?.data || {}));
        dispatch(changedCurriculum());
        enqueueSnackbar('Element updated successfully', { variant: 'success' })
        return { error: false }
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      return { error: true, message }
    }
  }

  const updateTypeElementsElementStructure = async (type, parent, childrenId, form = {}, ) => {
    try {
      const response = await updateTypeElementsElementStructureService(curriculumId, type, { parent, childrenId, form });
      if (!response.data && response.error) {
        return { error: true, message: response.error.message || 'An error ocurred'}
      } else {
        dispatch(updateElementsStructure(response?.data || {}));
        dispatch(changedCurriculum());
        enqueueSnackbar('Element updated successfully', { variant: 'success' })
        return { error: false }
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      return { error: true, message }
    }
  }

  return {
    errors,
    isLoadingList,
    updateBasicInformationElementStructure,
    updateElementsElementStructure,
    updateTypeElementsElementStructure,
    validateForm
  }
};

export default useCurriculumElementsStructure;